import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useEffect, useReducer, useRef } from 'react';
import Downshift from '@rexlabs/downshift';
import DownshiftContext from './context';
import { reducer, useStateReducerOverride } from './state-reducer';
import { MENU_STATES, SET_ITEMS, SET_MENU_STATE, ITEMS_LOADED } from './constants';
import { defaultFilter, defaultFreeformValueNormalizer, defaultItemToString, defaultStateReducer, defaultSelectedItemChanged } from './defaults';
import { noop } from 'lodash';
import { getCustomDownshift } from './custom-downshift';
var DownshiftProvider = DownshiftContext.Provider;
export function SelectCore(_ref) {
  var disabled = _ref.disabled,
      itemsResolver = _ref.items,
      _ref$shouldAddFreefor = _ref.shouldAddFreeformValue,
      shouldAddFreeformValue = _ref$shouldAddFreefor === void 0 ? false : _ref$shouldAddFreefor,
      _ref$shouldOpenOnInpu = _ref.shouldOpenOnInputFocus,
      shouldOpenOnInputFocus = _ref$shouldOpenOnInpu === void 0 ? true : _ref$shouldOpenOnInpu,
      _ref$shouldBackspaceR = _ref.shouldBackspaceRemove,
      shouldBackspaceRemove = _ref$shouldBackspaceR === void 0 ? true : _ref$shouldBackspaceR,
      _ref$shouldDeleteRemo = _ref.shouldDeleteRemove,
      shouldDeleteRemove = _ref$shouldDeleteRemo === void 0 ? true : _ref$shouldDeleteRemo,
      _ref$shouldBlurResetI = _ref.shouldBlurResetInput,
      shouldBlurResetInput = _ref$shouldBlurResetI === void 0 ? false : _ref$shouldBlurResetI,
      _ref$filter = _filterInstanceProperty(_ref),
      filter = _ref$filter === void 0 ? defaultFilter : _ref$filter,
      _ref$freeformValueNor = _ref.freeformValueNormalizer,
      freeformValueNormalizer = _ref$freeformValueNor === void 0 ? defaultFreeformValueNormalizer : _ref$freeformValueNor,
      _ref$onItemResolverEr = _ref.onItemResolverError,
      onItemResolverError = _ref$onItemResolverEr === void 0 ? console.error : _ref$onItemResolverEr,
      _ref$fixtures = _ref.fixtures,
      fixtures = _ref$fixtures === void 0 ? [] : _ref$fixtures,
      _ref$onFocus = _ref.onFocus,
      propOnFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      value = _ref.value,
      highlightedIndex = _ref.highlightedIndex,
      inputValue = _ref.inputValue,
      isOpen = _ref.isOpen,
      selectedItem = _ref.selectedItem,
      children = _ref.children,
      onChange = _ref.onChange,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? defaultItemToString : _ref$itemToString,
      _ref$stateReducer = _ref.stateReducer,
      stateReducer = _ref$stateReducer === void 0 ? defaultStateReducer : _ref$stateReducer,
      id = _ref.id,
      inputId = _ref.inputId,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      defaultIsOpen = _ref.defaultIsOpen,
      defaultHighlightedIndex = _ref.defaultHighlightedIndex,
      initialSelectedItem = _ref.initialSelectedItem,
      initialInputValue = _ref.initialInputValue,
      initialHighlightedIndex = _ref.initialHighlightedIndex,
      initialIsOpen = _ref.initialIsOpen,
      itemCount = _ref.itemCount,
      environment = _ref.environment,
      onSelect = _ref.onSelect,
      _ref$onStateChange = _ref.onStateChange,
      onStateChange = _ref$onStateChange === void 0 ? noop : _ref$onStateChange,
      _ref$onInputValueChan = _ref.onInputValueChange,
      onInputValueChange = _ref$onInputValueChan === void 0 ? noop : _ref$onInputValueChan,
      getItemId = _ref.getItemId,
      onOuterClick = _ref.onOuterClick,
      scrollIntoView = _ref.scrollIntoView,
      _ref$selectedItemChan = _ref.selectedItemChanged,
      selectedItemChanged = _ref$selectedItemChan === void 0 ? defaultSelectedItemChanged : _ref$selectedItemChan,
      getA11yStatusMessage = _ref.getA11yStatusMessage;

  var _useReducer = useReducer(reducer, {
    items: [],
    menuState: MENU_STATES.HELPER
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var items = state.items,
      menuState = state.menuState;
  var fixtureActions = useRef([]);
  var stateChangeActions = useRef([]); // Because there is a setTimeout when clicking
  // the toggle button in downshift we have to
  // prevent the downshift behaviour from happening if
  // we are also focusing the toggle button
  // const stopToggleButtonDefault = React.useRef(false);

  useEffect(function () {
    var ignore = false;

    function resolveItems() {
      return _resolveItems.apply(this, arguments);
    }

    function _resolveItems() {
      _resolveItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var newItems;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_Array$isArray(itemsResolver)) {
                  _context.next = 4;
                  break;
                }

                dispatch({
                  type: SET_ITEMS,
                  payload: itemsResolver
                });
                _context.next = 16;
                break;

              case 4:
                dispatch({
                  type: SET_MENU_STATE,
                  payload: MENU_STATES.LOADING
                });
                _context.prev = 5;
                _context.next = 8;
                return itemsResolver;

              case 8:
                newItems = _context.sent;

                if (!ignore) {
                  dispatch({
                    type: ITEMS_LOADED,
                    payload: newItems
                  });
                }

                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                onItemResolverError(_context.t0);
                dispatch({
                  type: SET_MENU_STATE,
                  payload: MENU_STATES.ERROR
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }));
      return _resolveItems.apply(this, arguments);
    }

    resolveItems();
    return function () {
      ignore = true;
    };
  }, [itemsResolver, onItemResolverError]);
  var stateReducerOverride = useStateReducerOverride({
    disabled: disabled,
    stateReducer: stateReducer,
    shouldBlurResetInput: shouldBlurResetInput
  });
  var setMenuState = useCallback(function (payload) {
    dispatch({
      type: SET_MENU_STATE,
      payload: payload
    });
  }, []);
  var handleInputValueChange = useCallback(function (value, stateAndHelpers) {
    onInputValueChange(value, _objectSpread(_objectSpread({}, stateAndHelpers), {}, {
      // Add setMenuState to the stateAndHelpers
      // so that we can update the menu state
      // on each keypress, in case we are debouncing
      // the itemsResolver update
      menuState: menuState,
      setMenuState: setMenuState
    }));
  }, [menuState, onInputValueChange, setMenuState]);
  var handleStateChange = useCallback(function (changes, stateAndHelpers) {
    var _context2;

    _forEachInstanceProperty(_context2 = _Object$keys(stateChangeActions.current)).call(_context2, function (key) {
      var _stateChangeActions$c, _stateChangeActions$c2;

      (_stateChangeActions$c = (_stateChangeActions$c2 = stateChangeActions.current)[key]) === null || _stateChangeActions$c === void 0 ? void 0 : _stateChangeActions$c.call(_stateChangeActions$c2, changes, stateAndHelpers);
    });

    onStateChange(changes, stateAndHelpers);
  }, [onStateChange]);
  var setStateChangeAction = React.useCallback(function (key, stateChangeAction) {
    if (typeof stateChangeAction === 'function') {
      stateChangeActions.current[key] = stateChangeAction;
    } else {
      throw new Error("Callback sent to 'setStateChangeAction' must be a function");
    }
  }, []);
  return /*#__PURE__*/React.createElement(Downshift, {
    id: id,
    inputId: inputId,
    labelId: labelId,
    menuId: menuId,
    defaultIsOpen: defaultIsOpen,
    defaultHighlightedIndex: defaultHighlightedIndex,
    initialSelectedItem: initialSelectedItem,
    initialInputValue: initialInputValue,
    initialHighlightedIndex: initialHighlightedIndex,
    initialIsOpen: initialIsOpen,
    itemCount: itemCount,
    highlightedIndex: highlightedIndex,
    inputValue: inputValue,
    isOpen: isOpen,
    selectedItem: value !== undefined ? value : selectedItem,
    environment: environment,
    onChange: onChange,
    onSelect: onSelect,
    onStateChange: handleStateChange,
    onInputValueChange: handleInputValueChange,
    getItemId: getItemId,
    itemToString: itemToString,
    stateReducer: stateReducerOverride,
    onOuterClick: onOuterClick,
    scrollIntoView: scrollIntoView,
    selectedItemChanged: selectedItemChanged,
    getA11yStatusMessage: getA11yStatusMessage
  }, function (downshift) {
    var customDownshift = getCustomDownshift({
      downshift: downshift,
      items: items,
      fixtures: fixtures,
      fixtureActions: fixtureActions,
      menuState: menuState,
      dispatch: dispatch,
      filter: filter,
      propOnFocus: propOnFocus,
      shouldOpenOnInputFocus: shouldOpenOnInputFocus,
      shouldBackspaceRemove: shouldBackspaceRemove,
      shouldDeleteRemove: shouldDeleteRemove,
      shouldAddFreeformValue: shouldAddFreeformValue,
      shouldBlurResetInput: shouldBlurResetInput,
      freeformValueNormalizer: freeformValueNormalizer,
      setMenuState: setMenuState,
      setStateChangeAction: setStateChangeAction
    }); // BAD HACK: This is just here to stop downshift
    // complaining about not calling getRootProps
    // This works as long as you spread getRootProps
    // onto the root element in the actual implementation
    // Can be refactored away when useAutocomplete from
    // Downshift is ready to be used

    customDownshift.getRootProps({}, {});
    return (
      /*#__PURE__*/
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      React.createElement(DownshiftProvider, {
        value: customDownshift
      }, children)
    );
  });
}